import { render, staticRenderFns } from "./IconManager.vue?vue&type=template&id=35e8bae8&scoped=true&"
import script from "./IconManager.vue?vue&type=script&lang=js&"
export * from "./IconManager.vue?vue&type=script&lang=js&"
import style0 from "./IconManager.vue?vue&type=style&index=0&id=35e8bae8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e8bae8",
  null
  
)

/* custom blocks */
import block0 from "./IconManager.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports